<template>
  <div :class="meterClass">
    <div class="meter__scale">
      <template v-for="i in length">
        <i
          :key="i"
          :class="pointClass(i - 1)"
          :style="getPointStyle(i)"
        />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stopped: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      length: 8,
      arrowPos: 2,
      rainbowInterval: null,
      rainbowIndex: 0,
      colors: ['#ff00ff', '#ff0000', '#ff6600', '#ffff00', '#00ff00', '#00ffff', '#0000ff'],
    };
  },
  computed: {
    isRainbow() {
      return this.value >= 1;
    },
    meterClass() {
      return {
        meter: true,
        'meter--stopped': this.stopped,
        'meter--hot': this.value >= 0.9,
        'meter--rainbow': this.isRainbow,
      };
    },
  },
  watch: {
    start() {
      this.update();
    },
    target() {
      this.update();
    },
    value() {
      this.update();
    },
    isRainbow(y) {
      if (y) {
        this.rainbowInterval = setInterval(this.playRainbow, 200);
      } else {
        clearInterval(this.rainbowInterval);
        this.rainbowIndex = 0;
      }
    },
  },
  mounted() {
    if (this.isRainbow) {
      this.rainbowInterval = setInterval(this.playRainbow, 100);
    }
  },
  methods: {
    update() {
      this.loading = true;
    },
    getPointColor(i) {
      return i + (this.colors.length - this.rainbowIndex);
    },
    playRainbow() {
      this.rainbowIndex = this.rainbowIndex - 1 < 0
        ? this.colors.length - 1
        : this.rainbowIndex - 1;
    },
    getPointStyle(i) {
      const style = {};

      if (this.isRainbow) {
        style.backgroundColor = this.colors[this.getPointColor(i) % this.colors.length];
      }

      return style;
    },
    pointValue(i) {
      const scaleLength = this.length - this.arrowPos;
      const step = this.length - i;
      return ((90 / scaleLength) * step) / 100;
    },
    pointClass(i) {
      const isActive = i < this.arrowPos
        || (!this.isRainbow && this.pointValue(i) <= this.value)
        || i === this.length - 1;
      return [
        'meter__point',
        i >= this.arrowPos ? `meter__point--${i - this.arrowPos}` : '',
        {
          'meter__point--active': isActive,
          'meter__point--arrow': `${i + 1}` === `${this.arrowPos}` && !this.isRainbow,
        },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/elements/Meter.vue